import type { EnoviaObjectType, FormerEnoviaObjectType } from '~/entities/content/idea/interfaces/space-ideas'

import type { SUBJECT_6W_URI } from '~/features-shared/libs/interfaces/entity'

import type { SwymResponse } from '~/interfaces/services-dto'

export interface RelatedLink {
  id: string
  idea_uri: string
  content_uri: string
  content_url: string
  content_title: string
  community_uri: SUBJECT_6W_URI
  community_title: string
  type: 'external_url' | 'internal' | EnoviaObjectType | FormerEnoviaObjectType
  content_key: string
}

export interface RelatedLinkBE {
  community_id: string
  community_title: string
  content_key: string
  content_title: string
  crdate: string
  id: string
  ideation_id: string
  leaf_model: string
  model: string
  model_id: string
  model_thumbnail_id: null
  model_title: string
  type: 'external_url' | 'internal' | EnoviaObjectType | FormerEnoviaObjectType
  update: string
  user_id: string
}

function parseRelatedLink(result: RelatedLinkBE, uri: string) {
  const baseUri = uri.split(':')
    .slice(0, 3)
    .join(':')

  return {
    id: result.id,
    type: result.type,
    idea_uri: uri,
    content_title: result.content_title || result.model_title,
    content_uri: result.type === 'internal' ? result.content_key : undefined,
    content_url: result.type === 'external_url' ? result.content_key : undefined,
    community_uri: `${baseUri}:community:${result.community_id}`,
    community_title: result.community_title,
    content_key: result.content_key,
  } as RelatedLink
}

export function parseIdeaRelatedLinksResponse(response: SwymResponse<RelatedLinkBE[]>, uri: string): SwymResponse<RelatedLink[]> {
  const result = response.result.map(el => parseRelatedLink(el, uri))
  return { ...response, result }
}

export function parseIdeaRelatedLinkResponse(response: SwymResponse<RelatedLinkBE>, uri: string): SwymResponse<RelatedLink> {
  const result = parseRelatedLink(response.result, uri)
  return { ...response, result }
}
